export enum MediaWallOutlet {
    AVAILABLE = 1,
    NOT_AVAILABLE = 0,
}
